import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-equal-opportunity-cell',
  templateUrl: './equal-opportunity-cell.component.html',
  styleUrls: ['./equal-opportunity-cell.component.scss']
})
export class EqualOpportunityCellComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
